import { EmptyMessage } from '@/components/shared/grid/components/EmptyMessage';
import { InfoBox } from '@/components/ui/InfoBox';
import { InformationSkeleton } from '@/components/ui/skeletons/InformationSkeleton';
import { PrimaryDocumentOwner } from '@/features/actsAndDocuments/primaryDocumentFiles';
import { DocumentFileModel } from '@/features/balanceActs/types';

import { DocumentsList } from './DocumentsList';

interface DocumentsSectionProps {
  documents: DocumentFileModel[] | null;
  owner: PrimaryDocumentOwner;
  isLoading: boolean;
}

export const DocumentsSection = ({
  documents,
  owner,
  isLoading,
}: DocumentsSectionProps) => {
  return (
    <InformationSkeleton loading={isLoading}>
      <InfoBox label='Додані документи'>
        {documents.length ? (
          <DocumentsList documents={documents} owner={owner} />
        ) : (
          <EmptyMessage title='Прикріплені документи відсутні' />
        )}
      </InfoBox>
    </InformationSkeleton>
  );
};
